<template>
  <v-container class="v-sheet-main-container screens elevation-12 scrollPlaylist"><!-- -->
    <v-toolbar flat class="v-toolbar-custom">
      <v-toolbar-title class="ma-2">{{ $t('screens.title') }}</v-toolbar-title>
      <v-tooltip open-delay="600" max-width="250" color="screens" bottom style="border-radius:8em!important;">
            <template v-slot:activator="{ on }">
              <v-text-field v-on="on" dark
                style="max-width:300px!important;"
                class="px-3 pt-1"
                placeholder="Rechercher"
                prepend-inner-icon="mdi-magnify"
                v-model="search"
                :clearable="true"
                clear-icon="mdi-close-circle"
                rounded
                filled
                dense
                :hide-details="true"
              ></v-text-field>
            </template>
            <span> Pour rechercher un écran saisissez son nom ou un mot clé. </span>
          </v-tooltip>
      <v-spacer></v-spacer>
      <v-menu 
        bottom
        left
        transition="slide-x-reverse-transition"
        origin="top right"
      >
        <template v-slot:activator="{ on: menu }">
          <v-tooltip color="rgba(0,0,0,0.2)" left>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn depressed fab small dark v-on="{...tooltip, ...menu}" class="custom-header-btn">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span> Aide contextuelle </span>
          </v-tooltip>
        </template>
        <v-card dark color="menuTooltip" class="helpMenu">
          <v-card-text class="body-1 font-weight-regular text-center pb-0" style="color:white!important">
            Vous souhaitez voir ce qu'affichent vos écrans ?
          </v-card-text>
          <v-card-text class="body-2 text-center" >
            C'est ici ! Sélectionnez en un pour voir apparaitre son programme de diffusion, sa <b>playlist</b>.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            Vous pourrez ainsi voir les médias <b>En diffusion</b>, <b>Programmés</b>, ou encore <b>Suspendus</b> sur cet écran et effectuer différentes actions <b>en direct</b>.
          </v-card-text>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-sheet id="my-content-wrapper" class="border-main-content elevation-3" style="height:calc(100% - 152px)!important;overflow:hidden;"><!---->
      <v-data-iterator
          hide-default-footer
          hide-default-header
          row
          wrap
          :no-results-text="noResultText"
          :search="search"
          :items="screens"
          :items-per-page="itemsperpage"
          style="height:100%;overflow-y:auto">
          transition="scale-transition"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col cols="12" class="d-flex flex-wrap">
                <v-card flat class="col-4 col-sm-3 col-md-2 justify-start inherit-background screens-image-bg image-overflow-visible" :ripple="false" v-for="item in props.items" @click="goToScreen(item)" :key="item.id">
                  <v-img class="mx-auto" :src="screenIcon(item.fk_screen_type)" max-width="180">
                  </v-img>
                  <v-card-text>
                      {{ item.server_name.replace(/_/g, ' ') }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      <!-- <div style="height:100%;overflow-y:auto">
        <v-row>
          <v-col cols="12">
            <v-card flat class="col-4 col-sm-3 col-md-2 d-inline-block float-left inherit-background screens-image-bg image-overflow-visible" :ripple="false" v-for="screen in screens" @click="goToScreen(screen)" :key="screen.id">
              <v-img class="mx-auto" :src="screenIcon(screen.fk_screen_type)" max-width="180">
              </v-img>
              <v-card-text>
                  {{ screen.server_name }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div> -->
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      screens: [],
      imgSrcLandscape: require('@/assets/images/light_ic_screen_landscape.png'),
      imgSrcPortrait: require('@/assets/images/light_ic_screen_portrait.png'),
      imgSrcLED: require('@/assets/images/light_ic_screen_led.png'),
      search: '',
      noResultText: 'Aucun résultat',
      itemsperpage: 10
    }
  },
  mounted () {
    this.screens = this.$store.state.selectedSite.screens
    this.itemsperpage = this.screens.length
  },
  methods: {
    goToScreen (screen) {
      this.$store.dispatch('setSelectedScreen', screen)
      this.$router.replace({
        name: 'ScreenManage'
      })
    },
    screenIcon (screenType) {
      if (screenType === 1) {
        return this.imgSrcLandscape
      } else if (screenType === 2) {
        return this.imgSrcPortrait
      } else if (screenType === 3) {
        return this.imgSrcLED
      }
    }
  },
  watch: {
    search () {
      this.search = this.search.replace(' ', '_')
    }
  }
}
</script>

<style scoped>

</style>
